import { useAuthorizeUser } from "@coworker/apprestructured/src/shared/hooks/useAuthorizeUser";
import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { Error } from "@coworker/apprestructured/src/login/components/Error/Error";
import { ErrorType } from "@coworker/apprestructured/src/shared/constants/errorTypes";
import React, { ReactElement } from "react";

export const AuthorizedUserRoute = ({
  children,
}: {
  children: ReactElement;
}) => {
  const userState = useAuthorizeUser();
  if (userState.isLoading) {
    return <SimpleDefaultLoadingScreen />;
  } else if (userState.isError) {
    return (
      <Error isAccessIssue={userState.errorType === ErrorType.FORBIDDEN} />
    );
  }
  return userState?.isActive ? children : <Error isAccessIssue={false} />;
};
